<template>
  <v-layout column>
    <!-- Name -->
    <v-layout
      align-baseline
      class="mb-2"
    >
      <v-text-field
        ref="timeframe-name-input"
        v-model="modelTimeframeName"
        data-cy="timeframe-name-textfield"
        :label="$t('name')"
        :placeholder="$t('timeframeNamePlaceholder')"
        :rules="[rules.maxLength]"
        @keyup.enter="$emit('submit')"
      />
    </v-layout>
    <v-layout
      :justify-center="$vuetify.breakpoint.xs"
      class="mb-2"
      :wrap="$vuetify.breakpoint.smAndDown"
      :class="{'offset-left': verySmallDevice}"
    >
      <!-- Weekdays -->
      <weekdays-picker
        :weekdays.sync="modelTimeframeWeekdays"
        :title="$t('chooseWeekdays')"
        style="max-width: 300px"
        show-workdays-button
        show-saturday-button
        class="mr-4"
      />
      <div
        class="d-flex"
        style="flex-flow: column nowrap"
      >
        <v-slide-y-reverse-transition>
          <div
            v-if="modelTimeframeStart == modelTimeframeEnd"
            class="text-xs-center blue--text caption text--darken-3 mb-2"
            :class="{'mt-2': $vuetify.breakpoint.xs}"
          >
            <v-icon
              small
              color="blue"
              class="mr-1"
            >
              all_inclusive
            </v-icon>
            {{ $t('timeframeActiveOnWholeDay') }}.
          </div>
        </v-slide-y-reverse-transition>
        <v-layout>
          <!-- Start Time -->
          <time-picker
            :time.sync="modelTimeframeStart"
            :title="$t('chooseTime')"
            :label="$t('from')"
            :minute-step-size="15"
            data-cy="timeframe-start-picker"
          />
          <div
            v-if="!verySmallDevice"
            class="mx-2"
          />
          <!-- End Time -->
          <time-picker
            :time.sync="modelTimeframeEnd"
            :title="$t('chooseTime')"
            :label="$t('to').toLowerCase()"
            :minute-step-size="15"
            data-cy="timeframe-end-picker"
          />
        </v-layout>
      </div>
    </v-layout>
    <!-- Group -->
    <upload-group-select
      :selected-upload-group-id.sync="modelTimeframeGroupId"
      :hint="$t('chooseUploadGroupForTimeframe')"
      :show-for-single-upload-group="showForSingleUploadGroup"
      class="mt-3"
    />
  </v-layout>
</template>

<script>
import uploadGroupSelect from '@/mixins/uploadGroupSelect';

import TimePicker from '@/components/TimePicker';
import UploadGroupSelect from '@/components/UploadGroupSelect';
import WeekdaysPicker from '@/components/WeekdaysPicker';

export default {
  components: {
    TimePicker,
    UploadGroupSelect,
    WeekdaysPicker,
  },
  mixins: [uploadGroupSelect],
  props: {
    timeframeStart: {
      type: String,
      required: true,
    },
    timeframeEnd: {
      type: String,
      required: true,
    },
    timeframeWeekdays: {
      type: Array[Number],
      required: true,
    },
    timeframeName: {
      type: String,
      default: '',
    },
    timeframeGroupId: {
      type: [Number, String],
      default: null,
    },
    /** Whether to show group select when only one choice exists. */
    showForSingleUploadGroup: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rules() {
      return {
        maxLength: (v) => v.length <= 128 || this.$t('tooLong'),
      };
    },
    modelTimeframeWeekdays: {
      get() {
        return this.timeframeWeekdays;
      },
      set(value) {
        return this.$emit('update:timeframeWeekdays', value);
      },
    },
    modelTimeframeStart: {
      get() {
        return this.timeframeStart || '';
      },
      set(value) {
        return this.$emit('update:timeframeStart', value);
      },
    },
    modelTimeframeEnd: {
      get() {
        return this.timeframeEnd || '';
      },
      set(value) {
        return this.$emit('update:timeframeEnd', value);
      },
    },
    modelTimeframeName: {
      get() {
        return this.timeframeName || '';
      },
      set(value) {
        return this.$emit('update:timeframeName', value);
      },
    },
    modelTimeframeGroupId: {
      get() {
        return this.timeframeGroupId;
      },
      set(value) {
        return this.$emit('update:timeframeGroupId', value);
      },
    },
    verySmallDevice() {
      return this.$vuetify.breakpoint.width < 360;
    },
  },
};
</script>

<style scoped>
/** Apply some offset for visual centering of wrapped pickers on mobile. */
.offset-left {
  position: relative;
  left: -12px;
}
</style>



// WEBPACK FOOTER //
// src/components/TimeframeWidget.vue